import React, { useState, useEffect } from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import {
  Button,
  Divider,
  Paper,
  IconButton,
  TextField,
  InputAdornment
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import styled from 'styled-components';
import { getOperations } from './operationsActions';

const CustomDivider = styled(Divider)`
  width: 1px;
  height: 40px;
  margin: 4px;
`;

const CustomPaper = styled(Paper)`
  padding: 2px 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

/**
 * Barre de recherche
 * @param {Function} setPage     Mettre à jour la page
 * @param {Function} setQuery    Mettre à jour les query de la requête
 * @param {String}   initParams  Query d'initialisation
 */
const Search = ({ dispatchGetOperations }) => {
  const history = useHistory();
  const { search: locationSearch } = useLocation();
  const [init, setInit] = useState(false);
  const defaultParams = {
    query: '',
    page: 1,
    resultsPerPage: 8
  };

  const getUrlParams = () =>
    qs.parse(locationSearch, { ignoreQueryPrefix: true });

  /**
   * Initialisation de l'url
   */
  useEffect(() => {
    const params = {
      ...defaultParams,
      ...getUrlParams()
    };
    history.replace({
      search: qs.stringify(params)
    });
    setInit(true);
  }, []);

  useEffect(() => {
    if (!init) {
      return;
    }
    const currentParams = getUrlParams();
    const params = {
      ...currentParams
    };
    dispatchGetOperations(params);
  }, [getUrlParams().page, dispatchGetOperations, init]);

  /**
   * Modification de la donnée inputText utiliser
   * dans la query. Pour rechercher dans les commandes
   * @param  {Object} event event
   */
  const handleChange = event => {
    history.replace({
      search: qs.stringify({
        ...getUrlParams(),
        query: event.target.value
      })
    });
  };

  /**
   * Function exécuté lors du clique sur l'icone de recherche
   */
  const search = () => {
    history.replace({
      search: qs.stringify({
        ...getUrlParams(),
        page: 1
      })
    });
    dispatchGetOperations(getUrlParams());
  };

  /**
   * Function exécuté lors du clique sur la touche Enter
   */
  const keyPressed = event => {
    if (event.key === 'Enter') {
      search();
    }
  };

  /**
   * Function permettant de reinitialiser tous les filtres de recherche,
   * elle remet aussi la pagination du tableau à 0
   */
  const reset = () => {
    history.replace({
      search: qs.stringify(defaultParams)
    });
    dispatchGetOperations(defaultParams);
  };

  return (
    <CustomPaper>
      <TextField
        style={{ width: '50%', marginRight: 30, marginLeft: 20 }}
        id="name"
        label="Recherche"
        value={qs.parse(locationSearch, { ignoreQueryPrefix: true }).query}
        onChange={handleChange}
        onKeyPress={keyPressed}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton aria-label="Search" onClick={search}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      <CustomDivider />
      <Button
        color="primary"
        variant="contained"
        disabled={'query' === ''}
        style={{ marginRight: 30, marginLeft: 30 }}
        onClick={reset}
      >
        Réinitialiser
      </Button>
    </CustomPaper>
  );
};

const mapDispatchToProps = dispatch => ({
  dispatchGetOperations: params => dispatch(getOperations(params))
});

Search.propTypes = {
  dispatchGetOperations: PropTypes.func.isRequired
};

export default connect(
  null,
  mapDispatchToProps
)(Search);
